import script from "./RecommendationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendationForm.vue?vue&type=script&setup=true&lang=js"

import "./RecommendationForm.vue?vue&type=style&index=0&id=c96c822e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c96c822e"]])

export default __exports__